/** @format */
import TextGrid from "@Web/Blocks/TextGrid";
import { Box, Typography } from "@mui/material";
import { useLocales } from "locales";

const CompanyValues = (props) => {
  const { t } = useLocales();
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          align={"center"}
          color={"text.secondary"}
          sx={{ textTransform: "uppercase" }}
          variant={"h3"}
          fontWeight={600}
          margin={10}
        >
          {t("companyValues")}
        </Typography>
      </Box>
      <TextGrid number={1} {...props} width={4} length={6} />
    </Box>
  );
};

export default CompanyValues;
